/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';
import React from 'react';
import TypeStyle from './productTypeTag.module.scss';

function ProductTypeTag(props) {
  const {
    title, unitSize, unit, fontColor, resetStyle,
  } = props;


  const tagType = {
    new: {
      type: 1,
      title: '新品',
    }, // 新品
    member: {
      type: 2,
      title: '会员价',
    }, // 会员价
    perfer: {
      type: 3,
      title: '优惠价',
    }, // 优惠价
  };
  const priceTagColor = {
    new: '#CA5008', // 新品
    member: '#0077C8', // 会员价
    perfer: '#CC0008', // 优惠价
  };

  /**
   * @description 计算默认样式
   * @param ( string | number )* typeStyle  类型
   * @returns style
   */
  const defaultStyle = (typeTitle) => {
    switch (typeTitle) {
      case tagType.new.title:
        return {
          color: fontColor || priceTagColor.new,
          fontSize: `${unitSize}${unit}`,
        };
      case tagType.member.title:
        return {
          color: fontColor || priceTagColor.member,
          fontSize: `${unitSize}${unit}`,
        };
      case tagType.perfer.title:
        return {
          color: fontColor || priceTagColor.perfer,
          fontSize: `${unitSize}${unit}`,
        };
      default:
        return '';
    }
  };

  return (
    <>
      <span
        style={{
          ...defaultStyle(title),
          ...resetStyle,
        }}
        className={TypeStyle['product-type-tag-normal']}
      >
        {title}
      </span>
    </>
  );
}

ProductTypeTag.propTypes = {
  title: PropTypes.string,
  unit: PropTypes.string,
  unitSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fontColor: PropTypes.string,
  resetStyle: PropTypes.objectOf(PropTypes.any),
};
ProductTypeTag.defaultProps = {
  title: '新品', // 标签类型
  unit: 'rem', // 字体大小单位
  unitSize: '1', // 12/16
  fontColor: '', // 字体颜色（整体）
  resetStyle: {}, // resetStyle权限比fontColor大
};

export default ProductTypeTag;
